// src/firebase.js
import { initializeApp } from 'firebase/app';
import { getFirestore } from 'firebase/firestore';

const firebaseConfig = {
    apiKey: "AIzaSyAHRSMJeIKLXUw_KxKs6-7tgHQ2symOBl8",
    authDomain: "peelsnative.firebaseapp.com",
    projectId: "peelsnative",
    storageBucket: "peelsnative.firebasestorage.app",
    messagingSenderId: "435425864797",
    appId: "1:435425864797:web:efcab43915615acba871b4",
    measurementId: "G-4REFDPF1RG"
  };

const app = initializeApp(firebaseConfig);
const db = getFirestore(app);

export default db;
